import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.exchangePlaidLoading"],
  loading => loading
);
